export function sanctionsSourcesForJurisdiction(value) {
  const geo = String(value || '').trim().toLowerCase();
  if (!geo) return [];
  return ['uae', 'ae', 'are', 'united arab emirates'].includes(geo) ? ['ofac', 'un', 'uae'] : ['ofac', 'un'];
}
export function sanctionsNameStrength(match) {
  if (['strong', 'moderate', 'weak'].includes(match?.strength)) return match.strength;
  // Preserve interpretation of saved results produced by the previous scorer.
  const score = Number(match?.score);
  return score >= 0.9 ? 'strong' : score >= 0.75 ? 'moderate' : 'weak';
}
export function sanctionsMatchReason(match, displayedName = '') {
  if (match?.matchReason) {
    const comparedName = String(match?.matchedName || '').trim();
    const displayKey = value => String(value || '').normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
    if (match.matchType === 'normalized' && match.matchedNameKind !== 'alias' &&
        comparedName && displayedName && displayKey(comparedName) !== displayKey(displayedName)) {
      return `${match.matchReason} · Compared name: ${comparedName}`;
    }
    return match.matchReason;
  }
  const type = String(match?.matchType || '').toLowerCase();
  if (['reordered', 'token_set_exact'].includes(type)) return 'Same name in a different word order';
  if (type === 'exact') return 'Exact name match';
  if (type.includes('alias')) return 'Matches a listed alias';
  if (type.includes('fuzzy')) return 'Similar spelling';
  if (type === 'initials') return 'Initials match the name';
  if (type === 'partial' || /contains|overlap|token/.test(type)) return 'Partial name match';
  return '';
}

// Name-only initial ranking. Review lists apply identity-outcome ordering next.
export function compareSanctionsNameMatches(a, b) {
  const category = value => ({ strong: 0, moderate: 1, weak: 2 }[sanctionsNameStrength(value)] ?? 3);
  return category(a) - category(b) || (Number(b.score) || 0) - (Number(a.score) || 0);
}

export function sanctionsSubjectFingerprint(meta = {}) {
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  return JSON.stringify([meta.subjectType || 'individual', clean(meta.givenNames), clean(meta.familyName), clean(meta.dateOfBirth), clean(meta.nationality), clean(meta.domicileCountry)]);
}

export function sanctionsScreeningFailureMessage(errors = []) {
  const incomplete = errors.filter(error => error.code === 'insufficient_name');
  if (incomplete.length === errors.length && incomplete.length) {
    return `Enter the complete name to screen: ${incomplete.map(error => error.name).join(' · ')}`;
  }
  return incomplete.length
    ? `Enter the complete name to screen: ${incomplete.map(error => error.name).join(' · ')}. Other subjects could not be screened; please try again.`
    : 'Some subjects could not be screened. Please try again.';
}
